import styles from './style.postcss';

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import is from 'is_js';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as groupActions } from 'containers/Group';
import { actions as grammaProActions } from 'data/GrammaPro';
import { connect, Button, moment } from 'omni-common-ui';
import CourseViewTable from 'components/CourseViewTable';
import Languages from 'domain/Languages';

const DEFAULT_CELL = '';
const COLUMN_ID = 'id-ID';
const COLUMN_RU = 'ru-RU';
const COLUMN_CN = 'zh-CN';
const COLUMN_EN = 'en-US';

const COUNTRY_LANGUAGE_MAPPING = {
  CN: [COLUMN_CN, COLUMN_EN],
  ID: [COLUMN_ID, COLUMN_EN, COLUMN_CN],
  RU: [COLUMN_RU, COLUMN_EN],
};

class GarammaPro extends PureComponent {
  constructor(props) {
    super(props);
    this._renderCell = this._renderCell.bind(this);
  }

  componentWillMount() {
    this.props.fetchGrammaPro(this.props.groupId);
  }

  _renderReport(reportUrl, date) {
    if (is.existy(reportUrl)) {
      return <a href={reportUrl} target="_blank"><Button>{`REPORT ON ${this._getDate(date)}`}</Button></a>;
    }
    return DEFAULT_CELL;
  }

  _getDate(date) {
    return is.existy(date) ? this._transformDate(date) : DEFAULT_CELL;
  }

  _renderDate(date) {
    if (is.existy(date)) {
      return <span className={styles.GrammarPro_report_date}>{this._transformDate(date)}</span>;
    }
    return <span>{DEFAULT_CELL}</span>;
  }

  _renderPeriod(start, end) {
    if (is.existy(start) && is.existy(end)) {
      return `${this._transformDate(start)} to ${this._transformDate(end)}`;
    }
    return DEFAULT_CELL;
  }

  _renderRportByLanguageCode(reports, languageCode) {
    const report = reports && reports.find((r) =>
      r.get('languageCode') === languageCode
    );
    const reportUrl = report && report.get('reportUrl');
    const date = report && this._transformDate(report.get('reportGeneratedDate'));
    return report ?
      <div className={styles.GrammarPro_report}>
        {this._renderReport(reportUrl, date)}
      </div> : DEFAULT_CELL;
  }

  _renderCell(member, columnId) {
    const { grammaPros } = this.props;
    if (! member || ! grammaPros) {
      return DEFAULT_CELL;
    }
    const grammaPro = grammaPros.get(`${member.studentGeneralInfo.id}`);
    if (! grammaPro) return DEFAULT_CELL;
    const reports = grammaPro.reports;
    const activationStart = grammaPro.activationStartDate;
    const activationEnd = grammaPro.activationEndDate;
    switch (columnId) {
      case COLUMN_CN:
        return this._renderRportByLanguageCode(reports, COLUMN_CN);
      case COLUMN_EN:
        return this._renderRportByLanguageCode(reports, COLUMN_EN);
      case COLUMN_ID:
        return this._renderRportByLanguageCode(reports, COLUMN_ID);
      case COLUMN_RU:
        return this._renderRportByLanguageCode(reports, COLUMN_RU);
      case 'activationPeriod':
        return this._renderPeriod(activationStart, activationEnd);
      default:
        return DEFAULT_CELL;
    }
  }

  _transformDate(date) {
    if (! date) return '';
    return moment.utc(date).clone().tz(this.props.timeZone).format('YYYY-MM-DD');
  }

  _renderTableHeader() {
    const languages = COUNTRY_LANGUAGE_MAPPING[this.props.countryCode];
    if (! is.existy(languages)) return null;
    return (
      <CourseViewTable.Header>
        <CourseViewTable.Row>
          <CourseViewTable.Cell columnId="activationPeriod" small>
            Activation Period
          </CourseViewTable.Cell>
          {
            languages.map((languageCode) =>
              <CourseViewTable.Cell columnId={languageCode} small>
                {Languages.getDisplayName(languageCode)}
              </CourseViewTable.Cell>
            )
          }
        </CourseViewTable.Row>
      </CourseViewTable.Header>
    );
  }

  render() {
    const { members } = this.props;
    if (! members) return null;
    return <div className={styles.GrammarPro}>
      <div className={styles.GrammarPro_wrapper}>
        <CourseViewTable students={members}>
          {this._renderTableHeader()}
          <CourseViewTable.Body>{this._renderCell}</CourseViewTable.Body>
        </CourseViewTable>
      </div>
    </div>;
  }
}

GarammaPro.propTypes = {
  countryCode: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  grammaPros: PropTypes.object,
  buildRoute: PropTypes.func,
  timeZone: PropTypes.string.isRequired,
  fetchGrammaPro: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const { groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const { countryCode, timeZone } = groupActions.getCentre(state, groupId);
  const grammaPros = state
    .get('rootReducer')
    .get('grammaPro')
    .get(`${groupId}`);
  return {
    countryCode,
    timeZone,
    members,
    groupId,
    grammaPros,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    {},
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(GroupMembers, dispatch),
    bindActionCreators(grammaProActions, dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GarammaPro);



// WEBPACK FOOTER //
// ./containers/Group/GrammaPro/component.jsx